<template>
  <div class="analysisTable">
      <div class="analysisTable__header">
          <div class="analysisTable__header--icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#44A561" d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm0 2h7v5h5v11H6zm2 8v2h8v-2zm0 4v2h5v-2z"/></svg>
          </div>
          <div class="analysisTable__header--title ml-2">Informações complementares</div>
      </div>
      <div class="analysisTable__content" v-if="!isLoading">
          <div class="analysisTable__content--list">
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Nacionalidade</div>
                          <div class="item__container--value">{{ Nationality }}</div>
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Nome do pai</div>
                          <div class="item__container--value">{{ FatherName }}</div>
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Nome da mãe</div>
                          <div class="item__container--value">{{ motherName }}</div>
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Data de registro fiscal</div>
                          <div class="item__container--value">{{ TaxRegistrationDate }}</div>
                          
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Possui Óbito?</div>
                          <div class="item__container--value">{{ Death }}</div>
                          
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Score de singularidade do nome</div>
                          <div class="item__container--value">{{ NameUniquenessScore }}</div>
                          
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Documento alternativo</div>
                          <div class="item__container--value">{{ AlternativeDocument }}</div>
                          
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item no-border">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Data de criação</div>
                          <div class="item__container--value">{{ CreationDate }}</div>
                          
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div v-else class="row justify-content-center p-5">
          <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
          </div>
      </div>
  </div>

</template>

<script>
export default {
  name: 'complementaryEnrichment',
  props: {
      data: {
          type: Object,
          required: true
      },
      count: {
          type: Object,
          required: false
      },
  },
  computed: {
      isLoading() {
        return this.$store.getters["getLoadingAnalysis"]
      },
      Nationality() {
          return this.data && this.data.birth_country ? this.data.birth_country : '---';
      },
      FatherName() {
          return this.data && this.data.father_name ? this.data.father_name : '---';
      },
      motherName() {
          return this.data && this.data.mother_name ? this.data.mother_name : '---';
      },
      TaxRegistrationDate() {
        if(this.data && this.data.tax_id_status_registration_date){
            const date = new Date(this.data.tax_id_status_registration_date);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
        return '---';
      },
      Death() {
          return this.data && this.data.has_obit_indication ? this.data.has_obit_indication ? 'Sim' : 'Não' : '---';
      },
      NameUniquenessScore() {
          return this.data && this.data.name_uniqueness_score ? this.data.name_uniqueness_score : '---';
      },
      AlternativeDocument() {
          return this.data && this.data.alternative_id_numbers ? this.data.alternative_id_numbers : '---';
      },
      CreationDate() {
        if(this.data && this.data.creation_date){
            const date = new Date(this.data.creation_date);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
        return '---';
      },

  },
};
</script>

<style scoped lang="scss">
.analysisTable {
  width: 100%;
  margin: 20px 0px 0px 0px;
  border: solid 1px #E5E5E5;
  border-radius: 10px ;
  padding-top: 15px;


  &__header {
      padding: 0px 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center; 
      gap: 10px;

      &--icon {
          flex-shrink: 0;
      }

      &--title {
          color: #44A561;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          margin-left: 14px;
      }
  }

  &__content {
      height: auto;
      width: 100%;

      hr {
          background: #E5E5E5;
      }

      &--list {
          height: auto;
          width: 100%;
          margin: 20px 0px;

          .item {
              border-bottom: solid 1px #E5E5E5;
              position: relative;

              &__container {
                  padding: 20px;

                  &--title {
                      color: #B1B1B1;
                      font-size: 0.8em;
                      font-style: normal;
                      font-weight: 400;
                      line-height: normal;
                  }

                  &--value {
                      color: #141414;
                      font-size: 0.9em;
                      font-style: normal;
                      font-weight: 600;
                      line-height: normal;
                      width: calc(100% - 40px);
                      overflow-x: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                  }

                  &--pill {
                      position: absolute;
                      right: 20px;
                      top: 30%;
                      width: auto;
                      font-size: 0.7em;
                      padding: 4px 10px;
                      font-size: 12px;
                      font-style: normal;
                      font-weight: 600;
                      line-height: normal;
                      border-radius: 50px;


                  }
              }

          }

          .no-border .item {
                border-bottom: none;
            }

      }
  }
}

.blue {
  background: rgba(54, 130, 243, 0.10);
  color: #3682F3;
}

.red {
  background: rgba(255, 95, 95, 0.10);
  color: #FF5F5F;
}
</style>